import {Schema} from 'normalizr';

import {transformUtil} from 'js-utils/transformation';
import {sdkRequest} from 'js-utils/http';
import {formatUrl} from 'url-lib';

const organizersUrl = (organizerId) => `/api/v3/destination/organizers/${organizerId}/`;
const followOrganizerUrl = (organizerId) => `/api/v3/destination/organizers/${organizerId}/follow/`;
const unfollowOrganizerUrl = (organizerId) => `/api/v3/destination/organizers/${organizerId}/unfollow/`;

const _validateFollowed = (response) => {
    if (response.followedByYou) {
        return response;
    }

    return Promise.reject();
};

const _validateUnfollowed = (response) => {
    if (!response.followedByYou) {
        return response;
    }

    return Promise.reject();
};

const _transformResponse = (response) => {
    const schema = new Schema('results');

    const transformedContent = transformUtil({
        response,
        schema,
    });

    return transformedContent.entities.results[transformedContent.result];
};

export const followOrganizer = (organizerId) => sdkRequest(followOrganizerUrl(organizerId), {method: 'POST'})
    .then(_transformResponse).then(_validateFollowed);

export const unfollowOrganizer = (organizerId) => sdkRequest(unfollowOrganizerUrl(organizerId), {method: 'POST'})
    .then(_transformResponse).then(_validateUnfollowed);

export const getOrganizer = (organizerId) => sdkRequest(
    formatUrl(
        organizersUrl(organizerId),
        {
            'expand.destination_profile': 'image',
        }
    )
)
    .then(_transformResponse);
